import { useContext, useState } from 'react';
import RankOneIcon from '../../assets/icons/RankOneIcon';
import RankThreeIcon from '../../assets/icons/RankThreeIcon';
import RankTwoIcon from '../../assets/icons/RankTwoIcon';
import { useLocation } from 'react-router-dom';
import { useGlobalState } from '../../contexts/GlobalState';
import { AuthContext } from '../../contexts/AuthContext';
import Table from '../../ui/Table';
import GreenpillPagination from './GreenpillPagination';
import { formatNumber } from '../../helpers/formatNumber';
import Loader from '../../ui/Loader';
import SubHeading from '../../ui/SubHeading';
import TopInLead from '../../assets/icons/TopInLead';
import AvatarImage from '../../ui/AvatarImage';
const defaultAvatar = '../../assets/images/defaultAvatar.png';

const ranks = {
    1: <RankOneIcon />,
    2: <RankTwoIcon />,
    3: <RankThreeIcon />,
};

export function GreenpillLeaderboardTable({
    className,
    leaderboardData,
    currentPage,
    myLeaderDetails,
    setCurrentPage,
    loading,
    totalEntries,
    selectedLandscapes,
    color,
    entriesPerPage,
    entriesHandler,
}) {
    const [fetchedDetails, setFetchedDetails] = useState({});
    const [loadingRows, setLoadingRows] = useState({});
    const location = useLocation();
    const isLeaderboard = location.pathname.endsWith('leaderboard');
    const { state } = useGlobalState();
    const { state: authState } = useContext(AuthContext);

    const contracts = state?.landscapes.flatMap((l) =>
        l?.contractAddresses?.map((obj) => ({
            ...obj,
            collectionNumber: l?.nftCollectionNumber,
        }))
    );

    const redStateURIs = state?.landscapes
        .flatMap((l) => [l?.stateURIs?.[0], l?.stateURIs?.[1], l?.stateURIsForSolana?.[0], l?.stateURIsForSolana?.[1]])
        .filter(Boolean);

    const orangeStateURIs = state?.landscapes
        .flatMap((l) => [l?.stateURIs?.[2], l?.stateURIs?.[3], l?.stateURIsForSolana?.[2], l?.stateURIsForSolana?.[3]])
        .filter(Boolean);

    const greenStateURIs = state?.landscapes
        .flatMap((l) => [
            l?.stateURIs?.[4],
            l?.stateURIsForSolana?.[4],
            ...(l?.shockStateURIs || []),
            ...(l?.shockStateURIsForSolana || []),
        ])
        .filter(Boolean);

    // const fetchDetailsForUser = async (address, userName, solanaWallet) => {
    //     try {
    //         setLoadingRows((prev) => ({ ...prev, [userName]: true }));

    //         if (!address && !solanaWallet) {
    //             setFetchedDetails((prev) => ({
    //                 ...prev,
    //                 [userName]: { redNftCount: 0, orangeNftCount: 0, greenNftCount: 0 },
    //             }));
    //             return;
    //         }

    //         const counts = await fetchGreenpillCountWithColor(
    //             address,
    //             solanaWallet,
    //             contracts,
    //             redStateURIs,
    //             orangeStateURIs,
    //             greenStateURIs
    //         );

    //         setFetchedDetails((prev) => ({ ...prev, [userName]: counts }));
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     } finally {
    //         setLoadingRows((prev) => ({ ...prev, [userName]: false }));
    //     }
    // };

    // useEffect(() => {
    //     if (state?.landscapes?.length > 0 && leaderboardData?.length > 0) {
    //         const seen = new Set();
    //         leaderboardData.forEach(({ evmAddress, userName, walletAddress }) => {
    //             if (!seen.has(userName)) {
    //                 seen.add(userName);
    //                 fetchDetailsForUser(evmAddress, userName, walletAddress);
    //             }
    //         });
    //     }
    // }, [state?.landscapes, leaderboardData]);

    // const isSpecific = selectedLandscapes?.length > 0;
    // const renderNftCount = (userName, color) => {
    //     if (loadingRows[userName]) return <Loader color="fill-[#326F58]" />;
    //     if (isSpecific) {
    //         return fetchedDetails?.[userName]?.obj?.[selectedLandscapes?.[0]]?.[`${color}NftCount`] ?? '0';
    //     }
    //     return fetchedDetails?.[userName]?.[`${color}NftCount`] ?? '0';
    // };

    // const renderRow = (leaderboard, isMine = false) => {
    //     isMine ? console.log(leaderboard, 'leaderboard') : null;
    //     const myRow = leaderboardData?.find((m) => m?.userName === leaderboard?.userName) || {
    //         ...leaderboard,
    //         ...{
    //             impactPointsEarned: 0,
    //             amountFundedInUSD: 0,
    //             rank: '-',
    //             chainUsedMost: {
    //                 name: '',
    //                 image: '',
    //                 chainId: '',
    //             },
    //         },
    //     };

    //     return (
    //         <Table.Row key={myRow?.userName}>
    //             <td colSpan="7" className="p-0 px-3">
    //                 <div
    //                     className={`grid grid-cols-10 ${
    //                         isMine ? 'border border-[#326F58] shadow-border-green rounded-full' : ''
    //                     }`}
    //                 >
    //                     <div className="py-3 self-center justify-self-center">
    //                         {myRow?.rank <= 3 ? ranks[myRow?.rank] : myRow?.rank ?? '-'}
    //                     </div>
    //                     <div className="py-3 flex pr-2 items-center space-x-2 col-span-2">
    //                         <img
    //                             src={myRow?.profileImage || defaultAvatar}
    //                             alt={myRow?.userName}
    //                             className="w-8 h-8 rounded-full"
    //                         />
    //                         <span className="truncate">{myRow?.userName}</span>
    //                     </div>
    //                     <div className="py-3 col-span-2 self-center justify-self-center">
    //                         {formatNumber(myRow?.impactPointsEarned?.toFixed(2))}
    //                     </div>
    //                     <div className="py-3 self-center justify-self-center">
    //                         {renderNftCount(myRow?.userName, 'red')}
    //                     </div>
    //                     <div className="py-3 self-center justify-self-center">
    //                         {renderNftCount(myRow?.userName, 'orange')}
    //                     </div>
    //                     <div className="py-3 self-center justify-self-center">
    //                         {renderNftCount(myRow?.userName, 'green')}
    //                     </div>
    //                     <div className="py-3 flex items-center justify-center col-span-2 space-x-2">
    //                         {myRow?.chainUsedMost?.image ? (
    //                             <>
    //                                 <img
    //                                     src={myRow?.chainUsedMost?.image}
    //                                     alt={myRow?.chainUsedMost?.name}
    //                                     className="w-6 h-6 rounded-full"
    //                                 />
    //                                 <span className="capitalize">{myRow?.chainUsedMost?.name}</span>
    //                             </>
    //                         ) : (
    //                             <div className="flex w-full items-center justify-center">
    //                                 <span>-</span>
    //                             </div>
    //                         )}
    //                     </div>
    //                 </div>
    //             </td>
    //         </Table.Row>
    //     );
    // };

    return (
        <div className="overflow-auto pr-2  main">
            <div className="mt-16">
                <div className="grid gap-10 grid-cols-tableLeaderboard">
                    <div className="flex items-center">
                        <SubHeading className={'text-primaryInput'} type={'large'}>
                            Rank
                        </SubHeading>
                    </div>
                    <div className="flex items-center">
                        <SubHeading className={'text-primaryInput'} type={'large'}>
                            Name
                        </SubHeading>
                    </div>
                    <div className="flex items-center">
                        <SubHeading className={'text-primaryInput  '} type={'large'}>
                            Impact Points
                        </SubHeading>
                    </div>
                    <div className="flex items-center pr-[242px]">
                        <SubHeading className={'text-primaryInput'} type={'large'}>
                            Bounties Published
                        </SubHeading>
                        <div className="flex items-center">cores</div>
                    </div>
                </div>
                <div>
                    {leaderboardData.map((leaderBoardMember, index) => {
                        return (
                            <div
                                key={leaderBoardMember._id}
                                className="grid gap-10 grid-cols-tableLeaderboard py-4 border-b border-borderColor "
                            >
                                {index + 1 === 1 && <TopInLead className="place-self-center" />}
                                {index + 1 === 2 && <TopInLead color="#B3BAC7" className="place-self-center" />}
                                {index + 1 === 3 && <TopInLead color="#D03801" className="place-self-center" />}

                                {index + 1 > 3 && <p className="place-self-center">{index + 1}</p>}

                                <div className="flex items-center">
                                    <AvatarImage
                                        w="w-9"
                                        h="h-9"
                                        className="mr-3"
                                        url={leaderBoardMember.profileImage}
                                    />
                                    <p className="text-lg text-primaryInput  capitalize">
                                        {leaderBoardMember.userName}
                                    </p>
                                </div>

                                <p className="text-lg text-primaryInput   font-medium ">
                                    {(Number(leaderBoardMember?.impactPoints) / 1000).toFixed(2)}K
                                </p>
                                <div className="pr-[242px]">
                                    {/* <MultiColorProgressBar
                                        total={leaderBoardMember?.coreWiseImpactPoints}
                                        totalCorePoints={totalCorePoints}
                                        className="place-self-center w-full  "
                                        sections={[
                                            {
                                                percentage: earthPoints?.impactPoints ? earthPoints?.impactPoints : 0,

                                                color: 'bg-[#00BA34]',
                                            }, // Red section, 25%
                                            {
                                                percentage: energyPoints?.impactPoints ? energyPoints?.impactPoints : 0,
                                                color: 'bg-[#FBCF4E]',
                                            }, // Green section, 20%
                                            {
                                                percentage: socialPoints?.impactPoints ? socialPoints?.impactPoints : 0,
                                                color: 'bg-[#BA2C2C]',
                                            }, // Blue section, 15%
                                            {
                                                percentage: waterPoints?.impactPoints ? waterPoints?.impactPoints : 0,
                                                color: 'bg-[#76C8E8]',
                                            }, // Yellow section, 10%
                                        ]}
                                    /> */}
                                    progress
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* <Table className={`${className} min-w-[600px] overflow-hidden  `}>
                <Table.Header>
                    <Table.Row>
                        <td colSpan="7" className="px-3">
                            <div className="grid grid-cols-10">
                                <p className="py-4 px-3 font-semibold text-base justify-self-center">Rank</p>
                                <p className="py-4 font-semibold text-base col-span-2">Name</p>
                                <p className="py-4 font-semibold text-base justify-self-center col-span-2">
                                    Impact Points
                                </p>
                                <p className="py-4 font-semibold justify-self-center text-base">Red</p>
                                <p className="py-4 font-semibold justify-self-center text-base">Orange</p>
                                <p className="py-4 font-semibold justify-self-center text-base">Green</p>
                                <p className="py-4 font-semibold justify-self-center  text-base col-span-2">
                                    Chain Used Most
                                </p>
                            </div>
                        </td>
                    </Table.Row>
                </Table.Header>

                {loading ? (
                    <Loader color="fill-[#326F58]" />
                ) : leaderboardData?.length > 0 ? (
                    [
                        ...leaderboardData?.map((l, i) => (
                            <Table.Row key={l?.userName}>
                                <td colSpan="7" className="p-0 px-3">
                                    <div
                                        className={`grid grid-cols-10 ${
                                            false ? 'border border-[#326F58] shadow-border-green rounded-full' : ''
                                        }`}
                                    >
                                        <div className="py-3 self-center justify-self-center">
                                            {l?.rank <= 3 ? ranks[l?.rank] : l?.rank ?? '-'}
                                        </div>
                                        <div className="py-3 flex pr-2 items-center space-x-2 col-span-2">
                                            <img
                                                src={l?.profileImage || defaultAvatar}
                                                alt={l?.userName}
                                                className="w-8 h-8 rounded-full"
                                            />
                                            <span className="truncate">{l?.userName}</span>
                                        </div>
                                        <div className="py-3 col-span-2 self-center justify-self-center">
                                            {formatNumber(l?.impactPointsEarned?.toFixed(2))}
                                        </div>
                                        <div className="py-3 self-center justify-self-center">0</div>
                                        <div className="py-3 self-center justify-self-center">0</div>
                                        <div className="py-3 self-center justify-self-center">0</div>
                                        <div className="py-3 flex items-center justify-center col-span-2 space-x-2">
                                            {l?.chainUsedMost?.image ? (
                                                <>
                                                    <img
                                                        src={l?.chainUsedMost?.image}
                                                        alt={l?.chainUsedMost?.name}
                                                        className="w-6 h-6 rounded-full"
                                                    />
                                                    <span className="capitalize">{l?.chainUsedMost?.name}</span>
                                                </>
                                            ) : (
                                                <div className="flex w-full items-center justify-center">
                                                    <span>-</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </td>
                            </Table.Row>
                        )),
                    ]
                ) : (
                    <Table.Row>
                        <td colSpan="7" className="px-3 rounded-full">
                            <div className="grid grid-cols-10 border border-[#326F58] shadow-border-green rounded-full">
                                <div className="py-3 self-center justify-self-center">-</div>
                                <div className="py-3 flex items-center space-x-2 col-span-2">
                                    <img
                                        src={authState?.citizen?.profileImage || defaultAvatar}
                                        alt="avatar"
                                        className="w-8 h-8 rounded-full"
                                    />
                                    <span className="text-sm truncate font-medium">{authState?.citizen?.userName}</span>
                                </div>
                                <div className="py-3 self-center col-span-2 justify-self-center">-</div>
                                <div className="py-3 self-center justify-self-center">-</div>
                                <div className="py-3 self-center justify-self-center">-</div>
                                <div className="py-3 self-center justify-self-center">-</div>
                                <div className="py-3 self-center justify-self-center col-span-2">-</div>
                            </div>
                        </td>
                    </Table.Row>
                )}
            </Table> */}
            {/* {isLeaderboard && totalEntries > 10 && (
                <div className="w-[100%]     mx-auto">
                    <GreenpillPagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(totalEntries / 10)}
                        entriesPerPage={entriesPerPage}
                        entriesHandler={entriesHandler}
                        onPageChange={setCurrentPage}
                    />
                </div>
            )} */}
        </div>
    );
}
